<template>
  <div>
    <page-header>
      <h2>Группа риска</h2>
      <template #actions>
        <div class="d-flex align-items-baseline actions">
          <div class="search-wrapper mr-4">
            <div class="search-tooltip"><sup><i class="fa fa-info-circle text-gray" :title="searchTooltip"></i></sup></div>
            <div class="search-filed">
              <component-input
                @keyupEnter="onFiltersApply()"
                v-model="filters.searchText"
                placeholder="Введите данные для поиска..."
              ></component-input>
              <div
                @click="
                  filters.searchText = '';
                  onFiltersApply();
                "
                v-if="filters.searchText && filters.searchText.length"
                class="cross"
              >
                <icon-component name="cross" />
              </div>
              <button
                type="button"
                class="btn btn-default"
                v-on:click="onFiltersApply()"
              >
                <icon-component name="searchSvg" />
              </button>
            </div>
            <div
              v-if="keyboardSuggestion"
              class="search-suggestion"
            >
              Возможно, вы имели в виду:
              <span
                class="search-suggestion-link"
                @click="applySuggestion"
              >
                {{ keyboardSuggestion }}
              </span>
            </div>
          </div>

          <button-component v-if="canEdit" @click="editFullCard(0)"
            >Создать</button-component
          >
          <button-component
            kind="tertiary"
            :class="{ filtered: isFiltered }"
            @click="modals.filter = !modals.filter"
          >
            <template #prepend>
              <icon-component class="mr-2" name="filter" />
            </template>
            Фильтр
          </button-component>
        </div>
      </template>
    </page-header>

    <section class="content">
      <template v-if="page.items?.length">
        <div class="table-inner">
          <table class="table-custom">
            <thead>
              <tr>
                <th></th>
                <th>№</th>
                <th>
                  ФИО
                  <i
                    style="cursor: pointer"
                    @click="columnSort('Surname')"
                    class="ml-2 fas text-gray fa-sort-amount-down-alt"
                    :class="{
                      'fas text-black fa-sort-amount-up':
                        sortMode && sortColumn === 'Surname',
                      'text-black': sortColumn === 'Surname',
                    }"
                  ></i>
                </th>
                <th>Дата рождения</th>
                <th>ФИО представителя</th>
                <th>Степень родства</th>
                <th>Контактный телефон</th>
                <th>
                  Район
                  <i
                    style="cursor: pointer"
                    @click="columnSort('AddressDistrict.Name')"
                    class="ml-2 fas text-gray fa-sort-amount-down-alt"
                    :class="{
                      'fas text-black fa-sort-amount-up':
                        sortMode && sortColumn === 'AddressDistrict.Name',
                      'text-black': sortColumn === 'AddressDistrict.Name',
                    }"
                  ></i>
                </th>
                <th>
                  МО прикрепления
                  <i
                    style="cursor: pointer"
                    @click="columnSort('MedOrg.Name')"
                    class="ml-2 fas text-gray fa-sort-amount-down-alt"
                    :class="{
                      'fas text-black fa-sort-amount-up':
                        sortMode && sortColumn === 'MedOrg.Name',
                      'text-black': sortColumn === 'MedOrg.Name',
                    }"
                  ></i>
                </th>
                <th>Дата включения в Реестр</th>
                <th>Дата приема врача</th>
                <th>Статус</th>
                <th></th>
                <th v-if="canEditStatus"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in page.items"
                :key="item.id"
                :class="{ 'tmp-patient--redial': item.status === 7 }"
              >
                <td>
                  <menu-component class="actions" :actions="actions(item)" />
                </td>
                <td>{{ page.firstItemNumber + index }}</td>
                <td>
                  {{ item.surname }} {{ item.name }} {{ item.patronimic }}
                </td>
                <td>{{ $momentFormat(item.dateOfBirth, "DD.MM.YYYY") }}</td>
                <td>
                  {{ item.tmpRepresentatives[0].surname }}
                  {{ item.tmpRepresentatives[0].name }}
                  {{ item.tmpRepresentatives[0].patronimic }}
                </td>
                <td>{{ item.tmpRepresentatives[0].relationType?.name }}</td>
                <td>{{ item.tmpRepresentatives[0].phone }}</td>
                <td>{{ item.addressDistrictName }}</td>
                <td>{{ item.medOrgName }}</td>
                <td>{{ $momentFormat(item.created, "DD.MM.YYYY") }}</td>
                <td :class="dateVisitClass(item)">
                  {{ $momentFormat(item.dateVisitDoctor, "DD.MM.YYYY HH:mm") }}
                </td>
                <td>
                  <div
                    class="tmp-patients-status"
                    v-if="item.status != -1"
                    :title="
                      item.statusName +
                      (item.statusComment
                        ? ' (Комментарий: ' + item.statusComment + ')'
                        : '')
                    "
                  >
                    <!-- <span :title="item.statusComment">{{
                      item.statusName
                    }}</span> -->
                    <atom-icon :name="`tmp-patients-status-${item.status}`" />
                  </div>
                </td>
                <td>
                  <div v-if="item.status == 1">
                    <button
                      title="Перейти к карточке ЛРАС"
                      v-if="item.patientId"
                      class="btn"
                      @click="goToPatientCard(item.patientId)"
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 17 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.0586 0.633301C15.4753 0.633301 15.8294 0.779134 16.1211 1.0708C16.4128 1.36247 16.5586 1.71663 16.5586 2.1333V13.1333C16.5586 13.55 16.4128 13.9041 16.1211 14.1958C15.8294 14.4875 15.4753 14.6333 15.0586 14.6333H2.05859C1.64193 14.6333 1.28776 14.4875 0.996094 14.1958C0.704427 13.9041 0.558594 13.55 0.558594 13.1333V2.1333C0.558594 1.71663 0.704427 1.36247 0.996094 1.0708C1.28776 0.779134 1.64193 0.633301 2.05859 0.633301H15.0586ZM14.8711 13.1333C14.9961 13.1333 15.0586 13.0708 15.0586 12.9458V2.3208C15.0586 2.1958 14.9961 2.1333 14.8711 2.1333H2.24609C2.12109 2.1333 2.05859 2.1958 2.05859 2.3208V12.9458C2.05859 13.0708 2.12109 13.1333 2.24609 13.1333H14.8711ZM13.5586 10.2583V11.0083C13.5586 11.2583 13.4336 11.3833 13.1836 11.3833H6.93359C6.68359 11.3833 6.55859 11.2583 6.55859 11.0083V10.2583C6.55859 10.0083 6.68359 9.8833 6.93359 9.8833H13.1836C13.4336 9.8833 13.5586 10.0083 13.5586 10.2583ZM13.5586 7.2583V8.0083C13.5586 8.2583 13.4336 8.3833 13.1836 8.3833H6.93359C6.68359 8.3833 6.55859 8.2583 6.55859 8.0083V7.2583C6.55859 7.0083 6.68359 6.8833 6.93359 6.8833H13.1836C13.4336 6.8833 13.5586 7.0083 13.5586 7.2583ZM13.5586 4.2583V5.0083C13.5586 5.2583 13.4336 5.3833 13.1836 5.3833H6.93359C6.68359 5.3833 6.55859 5.2583 6.55859 5.0083V4.2583C6.55859 4.0083 6.68359 3.8833 6.93359 3.8833H13.1836C13.4336 3.8833 13.5586 4.0083 13.5586 4.2583ZM5.33984 3.85205C5.56901 4.06038 5.68359 4.3208 5.68359 4.6333C5.68359 4.9458 5.56901 5.21663 5.33984 5.4458C5.13151 5.65413 4.87109 5.7583 4.55859 5.7583C4.24609 5.7583 3.97526 5.65413 3.74609 5.4458C3.53776 5.21663 3.43359 4.9458 3.43359 4.6333C3.43359 4.3208 3.53776 4.06038 3.74609 3.85205C3.97526 3.62288 4.24609 3.5083 4.55859 3.5083C4.87109 3.5083 5.13151 3.62288 5.33984 3.85205ZM5.33984 6.85205C5.56901 7.06038 5.68359 7.3208 5.68359 7.6333C5.68359 7.9458 5.56901 8.21663 5.33984 8.4458C5.13151 8.65413 4.87109 8.7583 4.55859 8.7583C4.24609 8.7583 3.97526 8.65413 3.74609 8.4458C3.53776 8.21663 3.43359 7.9458 3.43359 7.6333C3.43359 7.3208 3.53776 7.06038 3.74609 6.85205C3.97526 6.62288 4.24609 6.5083 4.55859 6.5083C4.87109 6.5083 5.13151 6.62288 5.33984 6.85205ZM5.33984 9.85205C5.56901 10.0604 5.68359 10.3208 5.68359 10.6333C5.68359 10.9458 5.56901 11.2166 5.33984 11.4458C5.13151 11.6541 4.87109 11.7583 4.55859 11.7583C4.24609 11.7583 3.97526 11.6541 3.74609 11.4458C3.53776 11.2166 3.43359 10.9458 3.43359 10.6333C3.43359 10.3208 3.53776 10.0604 3.74609 9.85205C3.97526 9.62288 4.24609 9.5083 4.55859 9.5083C4.87109 9.5083 5.13151 9.62288 5.33984 9.85205Z"
                          fill="#ABABB3"
                        />
                      </svg>
                    </button>
                    <button
                      v-else
                      @click="createPatientCard(item.id)"
                      class="btn"
                      title="Экспорт в реестр ЛРАС"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                </td>
                <td v-if="canEditStatus">
                  <button
                    @click="editCard(item)"
                    class="btn"
                    title="Сменить статус"
                  >
                    <i class="fa fa-pen"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-if="page.pagesTotal > 1">
          <Pagination
            :page-count="page.pagesTotal"
            :current-page="page.pageNumber"
            @change="onPageChange($event)"
          />
        </div>
        <div>
          <PageCounter
            :isFiltered="isFiltered"
            :totalCount="totalCount"
            :filteredCount="page.itemsTotal"
          />
        </div>
      </template>
      <template v-else>
        <EmptyListMessage />
      </template>
      <section class="modals">
        <transition name="filter">
          <div class="filter" v-if="modals.filter">
            <TmpPatientsFilters
              v-bind:filters="filters"
              v-on:apply="onFiltersApply($event)"
              v-on:reset="onFiltersReset($event)"
            />
          </div>
        </transition>
        <modal-component
          v-if="modals.cardView.show"
          title="Просмотр карточки"
          @close="modals.cardView.show = false"
          size-class="modal-xl"
        >
          <TmpPatientView
            :id="modals.cardView.id"
            @close="modals.cardView.show = false"
          ></TmpPatientView>
        </modal-component>
        <modal-component
          v-if="modals.cardFull.show"
          title="Редактирование карточки"
          @close="modals.cardFull.show = false"
          size-class="modal-xl"
        >
          <TmpPatientCard
            :id="modals.cardFull.id"
            @save="afterSaveFullCard"
            @close="modals.cardFull.show = false"
          ></TmpPatientCard>
        </modal-component>
        <modal-component
          v-if="modals.card.show"
          title="Смена статуса"
          @close="modals.card.show = false"
          size-class=""
        >
          <TmpPatientStatusCard
            :tmpPatient="modals.card.item"
            @save="afterSaveCard"
            @close="modals.card.show = false"
          ></TmpPatientStatusCard>
        </modal-component>
      </section>
    </section>
  </div>
</template>

<script>
import API from "../api/poll";
import TmpPatientsFilters from "../components/TmpPatientsFilters.vue";
import ButtonComponent from "@/common/ui/ButtonComponent";
import PageHeader from "@/common/components/page/PageHeader";
import AtomIcon from "@/common/ui/Icon.vue";
import IconComponent from "@/common/ui/IconComponent";
import Constants from "../../../common/constants";
import filtermanager from "../../../common/mixins/filtermanager";
import TmpPatientCard from "./TmpPatientCard.vue";
import TmpPatientStatusCard from "./TmpPatientStatusCard.vue";
import TmpPatientView from "./TmpPatientView.vue";
import security from "../../../common/mixins/security";
import ModalComponent from "@/common/ui/ModalComponent";
import ComponentInput from "@/common/components/ComponentInput";
import MenuComponent from "@/common/ui/components/page/MenuComponent";
import FileAPI from "@/modules/file/api";
import PageCounter from "@/common/components/PageCounter";
import Utils from "@/common/utils";

export default {
  name: "TmpPatients",
  components: {
    AtomIcon,
    IconComponent,
    PageHeader,
    ButtonComponent,
    TmpPatientsFilters,
    TmpPatientCard,
    TmpPatientStatusCard,
    TmpPatientView,
    ModalComponent,
    ComponentInput,
    MenuComponent,
    PageCounter,
  },
  mixins: [filtermanager, security],
  created() {
    this.getTotalCount();
    this.loadPage();
    this.checkPermission(Constants.TmpPatientView).then((response) => {
      this.canEditStatus = response.data;
    });
    this.checkPermission(Constants.TmpPatientEdit).then((response) => {
      this.canEdit = response.data;
    });

    const filter = this.loadFilter();
    this.hideFilters = filter ? filter : this.filters;
  },
  data: () => ({
    request: {
      pageNumber: 1,
      pageSize: Constants.pageSize,
    },
    filters: {
      patientFio: "",
      status: -1,
      representativeFio: "",
      searchText: "",
      addressDistrictId: 0,
      medOrgIds: [],
    },
    hideFilters: {},
    page: {},
    modals: {
      filter: false,
      card: {
        show: false,
        item: null,
      },
      cardFull: {
        show: false,
        id: null,
      },
      cardView: {
        show: false,
        id: null,
      },
    },
    isFiltered: false,
    isLastFiltered: false,
    canEdit: false,
    canEditStatus: false,

    sortMode: false,
    sortColumn: "",
    totalCount: 0,
    searchTooltip: "Поиск осуществляется по ФИО ребенка и представителя, телефону"
  }),
  methods: {
    getTotalCount() {
      const self = this;
      API.search({ pageNumber: 1, pageSize: 1, status: -1 }).then(function (
        response
      ) {
        self.totalCount = response.data.itemsTotal;
      });
    },
    actions(item) {
      let acts = [
        {
          title: "Просмотр",
          icon: "eye",
          click: () => this.viewFullCard(item.id),
        },
      ];
      if (this.canEdit && item.createdById) {
        acts.push({
          title: "Редактировать",
          icon: "pen",
          click: () => this.editFullCard(item.id),
        });
        acts.push({
          title: "Удалить",
          icon: "delete",
          click: () => this.deleteFullCard(item.id),
        });
      }
      return acts;
    },
    onPageChange(pageNumber) {
      this.request.pageNumber = pageNumber;
      this.loadPage();
    },
    loadPage() {
      const filter = this.loadFilter();
      if (filter) {
        this.filters = filter;
        this.isFiltered = true;
      }
      var params = Object.assign(this.filters, this.request, {
        sortColumn: this.sortColumn,
        sortMode: this.sortMode,
      });
      API.search(params).then((response) => {
        this.page = response.data;
      });
    },
    onFiltersApply(filters) {
      if (filters) {
        this.filters = filters;
        this.hideFilters = filters;
        this.isFiltered = true;
        this.isLastFiltered = true;
        this.saveFilter(this.filters);
        this.filters.searchText = "";
      } else if (
        this.filters.searchText == null ||
        this.filters.searchText.trim().length == 0
      ) {
        this.filters = Object.assign({}, this.hideFilters);
        this.isFiltered = this.isLastFiltered;
        this.filters.searchText = "";
        if (this.isFiltered) this.saveFilter(this.filters);
      } else {
        var str = this.filters.searchText.trim();
        this.filters = Object.assign(
          {},
          {
            searchText: str,
          }
        );
        this.isFiltered = false;
        this.removeFilter();
      }
      this.modals.filter = false;
      this.request.pageNumber = 1;
      this.loadPage();
    },
    onFiltersReset(filters) {
      this.filters = filters || {};
      this.hideFilters = filters || {};
      this.request.pageNumber = 1;
      this.modals.filter = false;
      this.removeFilter();
      this.isFiltered = false;
      this.isLastFiltered = false;
      this.loadPage();
    },
    exportFile(item) {
      if (item.createdById) {
        this.download(item.anketaFileId, item.anketaFile);
      } else {
        API.exportFile(item.uid);
      }
    },
    download(id, file) {
      if (id) {
        FileAPI.download(id).then((response) => {
          const blob = new Blob([response.data], { type: file.fileType });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.target = "_blank";
          link.download = file.originalName;
          link.click();
          URL.revokeObjectURL(link.href);
        });
      }
    },

    viewFullCard(id) {
      this.modals.cardView.show = true;
      this.modals.cardView.id = id;
    },
    editFullCard(id) {
      this.modals.cardFull.show = true;
      this.modals.cardFull.id = id;
    },
    deleteFullCard(id) {
      Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
        if (res.isConfirmed) {
          API.delete(id)
            .then((response) => {
              Constants.alert.fire(
                "Удаление",
                response.data.message,
                response.data.success ? "success" : "error"
              );
              this.getTotalCount();
              this.loadPage();
            })
            .catch(() => {
              Constants.alert.fire("Удаление", Constants.commonError, "error");
            });
        }
      });
    },

    editCard(item) {
      this.modals.card.show = true;
      this.modals.card.item = item;
    },
    afterSaveFullCard() {
      this.modals.cardFull.show = false;
      this.loadPage();
    },
    afterSaveCard(item) {
      this.modals.card.show = false;

      var itemInTable = this.page.items.find((x) => x.id === item.id);
      if (itemInTable) {
        if (item.status == 1 && itemInTable.status !== 1) {
          Constants.alert
            .fire({
              title: "Подтверждение",
              text:
                "Внести запись о " +
                item.surname +
                " " +
                item.name +
                " " +
                item.patronimic +
                " в Регистр ЛРАС сейчас?",
              confirmButtonText: "Да",
              cancelButtonText: "Нет",
              showCancelButton: true,
              icon: "warning",
            })
            .then((res) => {
              if (res.isConfirmed) {
                this.createPatientCard(itemInTable.id);
              }
            });
        }

        itemInTable.dateVisitDoctor = item.dateVisitDoctor;
        itemInTable.status = -1; //item.status;
        itemInTable.statusName = item.statusName;
        itemInTable.statusComment = item.statusComment;
        itemInTable.fileId = item.fileId;

        this.$nextTick(() => {
          itemInTable.status = item.status;
        });
      }
    },
    goToPatientCard(patientId) {
      this.$router.push({
        name: "patientCard",
        params: { id: patientId, action: "view" },
      });
    },
    createPatientCard(tmpPatientId) {
      this.$router.push({
        name: "patientCard",
        params: { id: 0, tmpPatientId: tmpPatientId, action: "edit" },
        query: { tmpPatientId: tmpPatientId },
      });
      //this.$route.query.q1
    },

    dateVisitClass(item) {
      if (
        item.status == 0 &&
        item.dateVisitDoctor &&
        item.dateVisitDoctor < new Date(Date.now() + 60000 * 120).toISOString()
      ) {
        return "redDate";
      }
      return "";
    },

    columnSort(sortColumn) {
      if (this.sortColumn !== sortColumn) {
        this.sortMode = false;
      } else this.sortMode = !this.sortMode;

      this.sortColumn = sortColumn;

      this.loadPage();
    },

    applySuggestion() {
      this.filters.searchText = this.keyboardSuggestion;
      this.onFiltersApply();
    }
  },
  computed: {
    keyboardSuggestion() {
      const text = this.filters.searchText?.trim();
      if (!text) {
        return null;
      }

      // есть ли латинские буквы
      if (!/[a-z]/i.test(text)) {
        return null;
      }

      const converted = Utils.enToRu(text);

      return converted !== text
        ? converted
        : null;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "/src/assets/theme/default/colors.scss";

.content {
  padding: 16px 16px 0 16px;
  position: relative;
  overflow-y: visible;
  .filter {
    position: absolute;
    width: 350px;
    height: auto;
    top: 0;
    right: 0;
    overflow: hidden;
    background-color: transparent;
    opacity: 1;
    transition: opacity 0.2s;
  }
  .filter-enter, .filter-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .table-custom .tmp-patient--redial td {
    box-shadow: inset 0px 11px 8px -10px #ffb800,
      inset 0px -11px 8px -10px #ffb800;
    border-top: #ffb800 solid 2px;
    border-bottom: #ffb800 solid 2px;
    &:first-of-type {
      border-left: #ffb800 solid 2px;
    }
    &:last-of-type {
      border-right: #ffb800 solid 2px;
    }
  }
}
.filtered {
  color: $red;
  &:hover {
    color: $red-dark;
  }
}

.redDate {
  color: $red;
}
.search-filed {
  position: relative;
  width: 320px !important;
  input {
    height: 100%;
  }
  .cross {
    cursor: pointer;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 60px;
    .icon {
      width: 10px;
      height: 10px;
    }
  }
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    background-color: #438ef0;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    .icon {
      width: 20px;
      height: 23px;
    }
  }
}

.tmp-patients-status {
  // display: flex;
  // gap: 5px;
  // justify-content: space-between;
  text-align: center;
}

.search-wrapper {
  display: inline-block;
  position: relative;
}
.search-tooltip {
  position: absolute;
  left: 3px;
  top: 1px;
  z-index: 1;
  // opacity: 0.5;

  // &:hover {
  //   opacity: 1;
  // }
}
</style>
